import { API_DOMAIN } from '@constants';
import type {
  LibItemMatrix,
  LibItemMedia,
  LibItemPano,
  LibItemPVideo,
  LibMatrixCache,
  LibPanoCache,
} from '@types';
import { teamConfig } from '@utils/teamConfig';
import axios from '@utils/axios';

/**
 * @description 获取全景素材数据
 * @param mediaId 素材id
 */
export function getLibPanoData(mediaId: number) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/pano/${mediaId}`,
    `${API_DOMAIN}/team/app/tours/panos/${mediaId}`
  );
  return axios.get<LibItemPano>(url);
}

/**
 * @description 获取矩阵素材数据
 * @param mediaId 素材id
 */
export function getLibMatrixData(mediaId: number) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/matrix/material/${mediaId}`,
    `${API_DOMAIN}/team/app/tours/matrixes/${mediaId}`
  );
  return axios.get<LibItemMatrix>(url);
}

/**
 * @description 获取全景视频素材数据
 * @param mediaId 素材id
 */
export function getLibPVideoData(mediaId: number) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/video_v2/materials/${mediaId}`,
    `${API_DOMAIN}/team/app/tours/videos/${mediaId}`
  );
  return axios.get<LibItemPVideo>(url);
}

/**
 * @description 获取媒体素材数据
 * @param mediaId 素材id
 */
export function getLibMediaData(mediaId: number) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/media/${mediaId}`,
    `${API_DOMAIN}/team/app/tours/media/${mediaId}`
  );
  return axios.get<LibItemMedia>(url);
}

export function editLibPano(id: number, data: Partial<LibItemPano>) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/pano/${id}`,
    `${API_DOMAIN}/team/app/tours/panos/${id}`
  );
  return axios.post(url, data);
}
export function editLibMatrix(id: number, data: Partial<LibItemMatrix>) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/matrix/material/${id}`,
    `${API_DOMAIN}/team/app/tours/matrixes//${id}`
  );
  return axios.post(url, data);
}
export function editLibPVideo(id: number, data: Partial<LibItemPVideo>) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/video_v2/materials/${id}`,
    `${API_DOMAIN}/team/app/tours/videos/${id}`
  );
  return axios.post(url, data);
}
export function editLibMedia(id: number, data: Partial<LibItemMedia>) {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/media/${id}`,
    `${API_DOMAIN}/team/app/tours/media/${id}`
  );
  return axios.post(url, data);
}

/**
 * 全景素材详情
 * @param id 素材id
 */
export function getLibPanoCache(id: number) {
  return axios.get<LibPanoCache>(`${API_DOMAIN}/panos/${id}`);
}

/**
 * 矩阵素材信息
 * @param ids 矩阵素材id/ids
 */
export function getLibMatrixCache(ids: number | number[]) {
  let idString: string;
  if (typeof ids === 'number') {
    idString = `${ids}`;
  } else {
    idString = ids.join(',');
  }
  return axios.get<LibMatrixCache[]>(
    `${API_DOMAIN}/matrix/material/info?ids=${idString}`
  );
}
